import * as React from 'react';

import { Box, HStack, Header, Icon } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { getQuestCheckConnectionText, getQuestLoadErrorText } from '../custom-text';

import { ImageWrapper, ReloadButton } from './styled';

export const QuestCardError = ({ refetch }: { refetch: () => void }) => {
  const errorHeaderMessage = getQuestLoadErrorText();

  useLogUserErrorMessage({
    message: errorHeaderMessage,
    severity: LogUserErrorSeverity.GeneralError,
    context: {
      moreInfo: 'quest-card-error.tsx',
    },
  });

  return (
    <Box
      borderRadius="xl"
      backgroundColor={getDesignToken('background-pattern')}
      shadow="2"
      margin={'$4'}
    >
      <ImageWrapper>
        <Icon variant="errorFill" size="12" color={getDesignToken('icon-disabled')} />
      </ImageWrapper>
      <Box padding="$4">
        <Header variant="headerTwo">{errorHeaderMessage}</Header>
        <Typography mb="$4">{getQuestCheckConnectionText()}</Typography>
        <HStack flexShrink={1}>
          <ReloadButton
            leftIcon={
              <Icon variant="refresh" size="sm" color={getDesignToken('border-color-error')} />
            }
            onPress={refetch}
          >
            {t('tryAgain')}
          </ReloadButton>
        </HStack>
      </Box>
    </Box>
  );
};
